import { z } from 'zod';

const WHOLE = /^\d+$/;

/** A whole number typed into a text input, kept as a string until the mapper. */
export const wholeIn = (min: number, max: number, message: string) =>
  z
    .string()
    .trim()
    .refine((v) => WHOLE.test(v) && Number(v) >= min && Number(v) <= max, { error: message });

/** Same, but empty means "not set" (the API's null). */
export const optionalWholeIn = (min: number, max: number, message: string) =>
  z
    .string()
    .trim()
    .refine((v) => v === '' || (WHOLE.test(v) && Number(v) >= min && Number(v) <= max), {
      error: message,
    });

export function isWholeIn(value: string, min: number, max: number): boolean {
  const v = value.trim();
  return WHOLE.test(v) && Number(v) >= min && Number(v) <= max;
}

/** `''` → null, anything else trimmed. */
export const emptyToNull = (value: string): string | null => {
  const trimmed = value.trim();
  return trimmed === '' ? null : trimmed;
};

export const toNumberOrNull = (value: string): number | null =>
  value.trim() === '' ? null : Number(value.trim());
